<template>
  <div v-show="showNonBankPad">
        <div class="form-group" :class="errorName">
        <label class="control-label">Name on Account</label>
        <input type="text" class="form-control" name="fund_bank_info_name_on_account" v-model="fundBankData.fund_bank_info_name_on_account"/>
        </div>
        <div class="form-group" :class="errorInstitution">
        <label class="control-label">Financial Institution Name</label>
        <input type="text" class="form-control" name="fund_bank_info_financial_institution_name" v-model="fundBankData.fund_bank_info_financial_institution_name"/>
        </div>
        <div class="form-group" :class="errorAddress">
        <label class="control-label">Branch Address</label>
        <input type="text" class="form-control" name="fund_bank_info_branch_address" v-model="fundBankData.fund_bank_info_branch_address"/>
        </div>
        <div class="form-group" :class="errorCity">
        <label class="control-label">City</label>
        <input type="text" class="form-control" name="fund_bank_info_branch_city" v-model="fundBankData.fund_bank_info_branch_city"/>
        </div>
      <div class="form-group" :class="errorRegion">
        <label class="control-label">Province</label>
        <select name="fund_bank_info_branch_region" class="form-control" v-model="fundBankData.fund_bank_info_branch_region">
          <option v-for="region in regions" :value="region.value" :selected="fundBankData.fund_bank_info_branch_region === region.value">{{ region.option }}</option>
        </select>
      </div>
      <div class="form-group" :class="errorPostalCode">
        <label class="control-label">Postal Code</label>
        <input type="text" class="form-control" name="fund_bank_info_branch_postal_code" v-model="fundBankData.fund_bank_info_branch_postal_code"/>
      </div>
      <div class="form-group" :class="errorTransit">
        <label class="control-label">Transit Number</label>
        <input type="text" class="form-control" name="fund_bank_info_transit" v-model="fundBankData.fund_bank_info_transit"/>
      </div>
      <div class="form-group" :class="errorBankId">
        <label class="control-label">Institution Number (Bank ID)</label>
        <input type="text" class="form-control" name="fund_bank_info_bank_id" v-model="fundBankData.fund_bank_info_bank_id"/>
      </div>
      <div class="form-group" :class="errorAccountNumber">
        <label class="control-label">Account Number</label>
        <input type="text" class="form-control" name="fund_bank_info_account_number" v-model="fundBankData.fund_bank_info_account_number"/>
      </div>
        <div class="form-group margin-top-40" :class="errorAccountType">
          <label>Type of Account</label>
            <div class="radio radio-primary" >
            <input id="chequing" type="radio" name="fund_bank_info_account_type" value="Chequing" v-model="fundBankData.fund_bank_info_account_type">
              <label>Chequing</label>
            </div>
            <div class="radio radio-primary" >
            <input id="savings" type="radio" name="fund_bank_info_account_type" value="Savings" v-model="fundBankData.fund_bank_info_account_type">
              <label>Savings</label>
            </div>
        </div>

        <div class="form-group margin-top-40">
          <p class="chequeInfo">If you are unsure of the Transit Number, Bank ID, or account number, they can be found along the bottom of any cheque for your account as shown below.</p>
          <img src="../../../images/check.jpg" alt="">
        </div>
  </div>
</template>

<script>
export default {
  name: "NonPadBank",
  props:['nonPadVisible','bankData','oldData','errors','hasPad'],
  data() {
    return {
      nonBankPadShow: null,
      regions: [
        {value:''   ,option:  '-- Select One --'},
        {value:'AB' ,option:  'Alberta'},
        {value:'BC' ,option:  'British Columbia'},
        {value:'SK' ,option:  'Saskatchewan'},
        {value:'MB' ,option:  'Manitoba'},
        {value:'ON' ,option:  'Ontario'},
        {value:'QC' ,option:  'Quebec'},
        {value:'NB' ,option:  'New Brunswick'},
        {value:'NS' ,option:  'Nova Scotia'},
        {value:'PE' ,option:  'Prince Edward Island'},
        {value:'NL' ,option:  'Newfoundland'},
        {value:'YT' ,option:  'Yukon'},
        {value:'NU' ,option:  'Nunavut'},
        {value:'NT' ,option:  'Northwest Territories'}
      ],
      fundBankData: {},
      errorState: [],
    }
  },
  methods: {
    checkErrorState() {
      if(this.errors !== '') {
        let fundKeys = Object.keys(this.fundBankData)
        let errorKeys = Object.keys(this.errors)
              errorKeys.forEach( key => {
              if(fundKeys.includes(key)) {
              this.errorState.push({field:key,value:true})
            }
        })
      }

    }
  },
  computed: {
    showNonBankPad() {
      if(this.nonPadVisible && this.hasPad === 'pad') {
        this.nonBankPadShow = false
      } else if(this.hasPad === 'no_pad') {
        this.nonBankPadShow = true
      } else if(!this.nonPadVisible && this.hasPad === 'pad') {
        this.nonBankPadShow = true
      }

      return this.nonBankPadShow
    },
    errorName() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_name_on_account' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorInstitution() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_financial_institution_name' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorAddress() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_branch_address' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorCity() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_branch_city' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorRegion() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_branch_region' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorPostalCode() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_branch_postal_code' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorTransit() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_transit' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorBankId() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_bank_id' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorAccountNumber() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_account_number' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    },
    errorAccountType() {
      let isError = false
      this.errorState.forEach(val => {
        if(val.field === 'fund_bank_info_account_type' ) {
          isError = true
        }
      })
      return isError ? 'error' : '';
    }
  },
  created() {
    this.fundBankData = this.bankData
    if(this.oldData.length !== 0) {
      this.fundBankData = this.oldData
    }
    this.checkErrorState()
  }
}
</script>